import { ownerService } from './ownerService';

export * from './ownerService';

export default ownerService;
